// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2aeCV","tabsBox":"styles_tabsBox__2BgF3","createButton":"styles_createButton__1FFPq"};